package com.nonopn.skydome.common.app.pages.documents

import com.nonopn.skydome.common.app.pages.main.model.DocumentHistoryItem
import com.nonopn.skydome.common.app.pages.main.model.DocumentHistoryType
import com.nonopn.skywatcher.common.api.DocumentsHistoryItem

fun DocumentHistoryItem.toApi() = DocumentsHistoryItem(
    id = id,
    type = type.name,
    siteName = siteName,
    createdAtSecondsUtc = createdAtSecondsUtc,
    latitude = latitude,
    longitude = longitude,
    impactLat = impactLat,
    impactLon = impactLon,
    impactTimestamp = impactTimestamp,
    impactAmplitude = impactAmplitude,
    impactPercent = impactPercent,
    impactExternalId = impactExternalId,
)

/** Null when the server sent a document type this app version does not know. */
fun DocumentsHistoryItem.toModel(): DocumentHistoryItem? {
    val documentType = DocumentHistoryType.entries.firstOrNull { it.name == type } ?: return null

    return DocumentHistoryItem(
        id = id,
        type = documentType,
        siteName = siteName,
        latitude = latitude,
        longitude = longitude,
        createdAtSecondsUtc = createdAtSecondsUtc,
        impactLat = impactLat,
        impactLon = impactLon,
        impactTimestamp = impactTimestamp,
        impactAmplitude = impactAmplitude,
        impactPercent = impactPercent,
        impactExternalId = impactExternalId,
    )
}
